export function createDeconstructionQuestionsConfig() {
	return {
		title: "Deconstruction Questions",
		instructions: "Name the meaning in your own words. Add contexts that seem relevant and leave uncertain connections open for discussion.",
		stages: [
			{id: "social", title: "Social context", description: "", itemPlaceholder: "Social expectations or messages", allowAlternatives: false},
			{id: "relational", title: "Relational context", description: "", itemPlaceholder: "Relationships or conversations", allowAlternatives: false},
			{id: "cultural", title: "Cultural context", description: "", itemPlaceholder: "Cultural messages or practices", allowAlternatives: false},
			{id: "historical", title: "Historical context", description: "", itemPlaceholder: "Earlier experiences or history", allowAlternatives: false},
			{id: "power", title: "Power context", description: "", itemPlaceholder: "Rules, institutions, or power", allowAlternatives: false},
		],
		contextMap: {
			focusLabel: "Belief, meaning, or problem story",
			focusPlaceholder: "Use the client's own words",
			effectsLabel: "Effects of this meaning",
			effectsPlaceholder: "Effects in your own words",
			reflectionLabel: "Emerging understanding",
			reflectionPlaceholder: "What now feels open for discussion",
			linkPlaceholder: "Describe a context in your own words",
			alternativesTitle: "Alternative values, preferences, or interpretations",
			alternativePlaceholder: "What other position is becoming possible?",
			promptsTitle: "Conversation questions",
			unfilledLabel: "Still open",
			coverageLabel: "Context areas with entries",
			alternativesCountLabel: "Alternatives entered",
			statusHeading: "Link status",
			addLinkLabel: "Add context",
			addAlternativeLabel: "Add alternative",
			archivedTitle: "Earlier context areas",
			heldMessage: "This map is held by the practitioner.",
			privateNoteLabel: "Practitioner note · private from client",
			visibility: "shared",
			statusOptions: [
				{value: "accepted", label: "Accepted"},
				{value: "tentative", label: "Tentative"},
				{value: "rejected", label: "Rejected"},
			],
			prompts: [],
		},
	}
}

export function createDeconstructionQuestionsDemoPayload() {
	return {
		stagedWorksheet: {
			context: "I always let people down.",
			reaction: "I keep saying yes even when I am exhausted.",
			theme: "Being available to everyone is an expectation I learned, not my whole identity.",
			stages: [
				{id: "social", items: [{id: "social_1", text: "People expect me to be available at all times", values: {statusId: "accepted", statusLabel: "Accepted"}}]},
				{id: "relational", items: [{id: "relational_1", text: "A former manager said I was unreliable", values: {statusId: "tentative", statusLabel: "Tentative"}}]},
				{id: "cultural", items: [{id: "cultural_1", text: "My family values constant productivity", values: {statusId: "rejected", statusLabel: "Rejected"}}]},
			],
			alternatives: [{id: "alternative_1", text: "I value reliability and can set limits."}],
		},
	}
}
